import {
  default as AntButton,
  ButtonProps as AntButtonProps,
} from "antd/lib/button";

import React from "react";

export function Button(props: Button.Props) {
  return <AntButton {...props} />;
}

export namespace Button {
  export type Props = AntButtonProps;
}
